export const BASE_CONTEXT = '/';
